module.exports = __webpack_public_path__ + "static/media/information.f6f14eed.svg";